import { useRootData } from '@hooks/hook';
import { BusinessObjectsState, CreditNoteApprovalState, CreditNoteSignState } from '@services/src/models';
import { Checkbox, Col, Divider, Radio, Row, Space, Switch } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { RadioChangeEvent } from 'antd/lib/radio';
import React from 'react';
import { IGlobalSearchStore } from 'stores/GlobalSearchStore';
import { IGridStore } from 'stores/GridStore';

import styles from './styles/PharmaciesNoteGroups.module.less';

interface IProps { }

export const PharmaciesNoteGroupsFilters = (props: IProps) => {
	const gridStore: IGridStore = useRootData((store) => store.gridStore);

	const globalSearchStore: IGlobalSearchStore = useRootData(
		(store) => store.globalSearchStore
	);

	const onFilter = (value: BusinessObjectsState) => {
		gridStore.searching.set(true);
		globalSearchStore.pharmacyPaymentsFilter.set({
			...globalSearchStore.pharmacyPaymentsFilter.get(),
			businessObjectsState: value,
		});
	};
	const onFilterCreditNoteApproval = (value: CreditNoteApprovalState) => {
		gridStore.searching.set(true);
		globalSearchStore.pharmacyPaymentsFilter.set({
			...globalSearchStore.pharmacyPaymentsFilter.get(),
			creditNoteApprovalState: value,
		});
	};
	const onFilterCreditNoteSignState = (value: CreditNoteSignState) => {
		gridStore.searching.set(true);
		globalSearchStore.pharmacyPaymentsFilter.set({
			...globalSearchStore.pharmacyPaymentsFilter.get(),
			creditNoteSignState: value,
		});
	};

	return (
		<Space className={styles.filters}>
			{/* <Divider type="vertical" style={{ height: 32 }} /> */}
			{/* <div style={{ padding: 12, border: '1px solid #e5e5e5', borderRadius: 8, background: '#fafafa' }}> */}
			<Row gutter={20}>
				<Col className="filter-box" >
					<Radio.Group
						onChange={(e: RadioChangeEvent) => onFilter(e.target.value)}

						defaultValue={
							globalSearchStore.pharmacyPaymentsFilter.get()
								.businessObjectsState
						}
					>
						<Radio value={BusinessObjectsState.CorrectOnly}>
							correct only
						</Radio>
						<Radio value={BusinessObjectsState.NotCorrectOnly}>
							incorrect only
						</Radio>
						<Radio value={BusinessObjectsState.All}>all</Radio>
					</Radio.Group>
				</Col>
				<Divider type="vertical" style={{ height: 28 }} />
				<Col className="filter-box">

					<Checkbox
						onChange={(event: CheckboxChangeEvent) => {
							gridStore.searching.set(true);

							globalSearchStore.pharmacyPaymentsFilter.set({
								...globalSearchStore.pharmacyPaymentsFilter.get(),
								zeroBalance: event.target.checked,
							});
						}}
						defaultChecked={
							globalSearchStore.pharmacyPaymentsFilter.get().zeroBalance
						}
					>
						Show balance 0
					</Checkbox>
				</Col>
				<Divider type="vertical" style={{ height: 28 }} />
				<Col className="filter-box">



					<Radio.Group
						onChange={(e: RadioChangeEvent) => onFilterCreditNoteApproval(e.target.value)}

						defaultValue={
							globalSearchStore.pharmacyPaymentsFilter.get()
								.creditNoteApprovalState
						}
					>
						<Radio value={CreditNoteApprovalState.Approved}>
							CNA
						</Radio>
						<Radio value={CreditNoteApprovalState.NotApproved}>
							no CNA
						</Radio>
						<Radio value={CreditNoteApprovalState.All}>all</Radio>
					</Radio.Group>
				</Col>
				<Divider type="vertical" style={{ height: 28 }} />
				<Col className="filter-box">
					<Radio.Group
						onChange={(e) => onFilterCreditNoteSignState(e.target.value)}
						defaultValue={globalSearchStore.pharmacyPaymentsFilter.get().creditNoteSignState}
					>
						<Radio value={CreditNoteSignState.Signed}>signed</Radio>
						<Radio value={CreditNoteSignState.NotSigned}>not signed</Radio>
						<Radio value={CreditNoteSignState.All}>all</Radio>
					</Radio.Group>
				</Col>
			</Row>

		</Space>

	);
};
